import CallModal from 'app/components/call/CallModal';
import { GetDeviceManager } from 'app/containers/rtc/DeviceManagerContext';
import React, { FunctionComponent } from 'react';
import { ExtractProps } from 'app/utils/types';

type Props = Omit<ExtractProps<typeof CallModal>, 'onClose'>;

const MessageModalInjectDependencies: FunctionComponent<Props> = (props: Props) =>
  <GetDeviceManager>{(manager) => manager &&
    <CallModal {...props} onClose={manager.dismiss} />
  }</GetDeviceManager>;

export default MessageModalInjectDependencies;
